module.exports = __webpack_public_path__ + "static/EmilyIsAway1-69aa17bfe40a02ac26ad35edd67230fb.webp";